import { render, staticRenderFns } from "./PageIllustration.vue?vue&type=template&id=642f94e0&"
import script from "./PageIllustration.vue?vue&type=script&lang=js&"
export * from "./PageIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports